export type AcceptedStaffInvitationStatus = 'linked' | 'already_linked' | 'no_matching_staff_profile';

export function acceptedInvitationMessage(status: AcceptedStaffInvitationStatus | null | undefined): string {
  void status;
  return 'You’re added to the team. Next, approve Gmail and Calendar access from Work account setup.';
}
